module.exports = __webpack_public_path__ + "static/media/pr.8eb64a78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pr.svg
// module id = 227
// module chunks = 0